module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Light.12c68403.eot";